module.exports = __webpack_public_path__ + "img/luntan_2018_04.ec6bf6bd.jpg";